module.exports = __webpack_public_path__ + "media/assets/images/payment/visa-35d7c410128ff080dde2f9854ff3dbcf.png";